import { useState } from 'react';
import { useMutation } from 'react-query';
import { AuthorizationAPI } from '../../constants/API';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { setUserRole } from '../../utils/Authorization/authorization';

export type UserType = {
  login: string;
  password: string;
};

export const useLogin = (
  setIsAuthenticated: (status: boolean) => void,
  redirectPath?: string
) => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {
    mutate: login,
    isLoading,
    isError
  } = useMutation(
    ['login'],
    async (data: UserType) =>
      axios.post(AuthorizationAPI.logIn, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }),
    {
      onSuccess(res) {
        setIsAuthenticated(true);
        setErrorMessage(null);
        setUserRole(res.data, navigate, redirectPath);
      },
      onError(error) {
        if (axios.isAxiosError(error)) {
          setErrorMessage((error.response?.data as { message?: string })?.message ?? error.message ?? null);
        } else {
          setErrorMessage(null);
        }
      }
    }
  );

  return { login, isLoading, isError, errorMessage };
};
